import { AbstractPmsApiService } from './abstract.service';
import { BillingTransaction } from '../models/billing-transaction.model';

/**
 * @class BillingTransactionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BillingTransaction>}
 */
export class BillingTransactionPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/billing/property/:propertyId/transactions(/:transactionId)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BillingTransaction}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BillingTransaction(attributes);
    }

    /**
     * @param {Property} property
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<BillingTransaction>>}
     */
    get(property, params = {}) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BillingTransaction} transaction
     * @param {Property} property
     * @returns {Promise.<BillingTransaction>}
     */
    create(transaction, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, transaction.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param transaction
     * @param property
     */
    show(transaction, property) {

        const url = this.url({
            propertyId: property.id,
            transactionId: transaction.id,
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BillingTransaction} transaction
     * @param {Property} property
     * @returns {Promise.<BillingTransaction>}
     */
    update(transaction, property) {

        const url = this.url({
            propertyId: property.id,
            transactionId: transaction.id,
        });

        return this.http
            .put(url, transaction.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/billing-transaction.service.js